"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentAdConceptSchema = exports.AgentAdConceptScenes = void 0;
const zod_1 = __importDefault(require("zod"));
const agent_ad_concept_shared_1 = require("./agent-ad-concept-shared");
const ActorInputSchema = agent_ad_concept_shared_1.ActorInputBase.extend({
    parameters: zod_1.default
        .object({
        actorUuid: zod_1.default.string(),
        actorFileUuid: zod_1.default.string().nullable(),
    })
        .nullable()
        .describe('If parameters is null, the user still needs to select an actor. Keep null during generation.'),
});
const VoiceInputSchema = agent_ad_concept_shared_1.VoiceInputBase.extend({
    parameters: zod_1.default
        .object({
        voiceUuid: zod_1.default.string(),
    })
        .nullable()
        .describe('If parameters is null, the user still needs to select a voice. Keep null during generation.'),
});
const ProductShotInputSchema = agent_ad_concept_shared_1.ProductShotInputBase.extend({
    parameters: zod_1.default
        .object({
        productShotFileUuid: zod_1.default.string().nullable(),
    })
        .nullable()
        .describe('If parameters is null, the user still needs to select a product. Keep null during generation.'),
});
const ImageInputSchema = agent_ad_concept_shared_1.ImageInputBase.extend({
    parameters: zod_1.default
        .object({
        imageFileUuid: zod_1.default.string().nullable(),
    })
        .nullable()
        .describe('Keep null during generation.'),
});
const VideoInputSchema = agent_ad_concept_shared_1.VideoInputBase.extend({
    parameters: zod_1.default
        .object({
        videoFileUuid: zod_1.default.string().nullable(),
    })
        .nullable()
        .describe('Keep null during generation.'),
});
const InputSchema = zod_1.default.object({
    actors: zod_1.default.array(ActorInputSchema),
    voices: zod_1.default.array(VoiceInputSchema),
    productShots: zod_1.default.array(ProductShotInputSchema),
    images: zod_1.default.array(ImageInputSchema),
    videos: zod_1.default.array(VideoInputSchema),
});
/**
 * Scenes
 * */
const SpeakingActorSceneSchema = agent_ad_concept_shared_1.SpeakingActorSceneSchemaShared.extend({
    uuid: zod_1.default.string(),
});
const UserProvidedBrollSceneSchema = agent_ad_concept_shared_1.UserProvidedBrollSceneSchemaShared.extend({
    uuid: zod_1.default.string(),
});
const GeneratedBrollSceneSchema = agent_ad_concept_shared_1.GeneratedBrollSceneSchemaShared.extend({
    uuid: zod_1.default.string(),
});
const GeneratedStaticSceneSchema = agent_ad_concept_shared_1.GeneratedStaticSceneSchemaShared.extend({
    uuid: zod_1.default.string(),
});
const UserProvidedStaticSceneSchema = agent_ad_concept_shared_1.UserProvidedStaticSceneSchemaShared.extend({
    uuid: zod_1.default.string(),
});
exports.AgentAdConceptScenes = zod_1.default.union([
    SpeakingActorSceneSchema,
    UserProvidedBrollSceneSchema,
    GeneratedBrollSceneSchema,
    GeneratedStaticSceneSchema,
    UserProvidedStaticSceneSchema,
]);
/**
 * Misc
 * */
const CaptionsSchema = agent_ad_concept_shared_1.CaptionsSchemaShared;
const BackgroundMusicSchema = agent_ad_concept_shared_1.BackgroundMusicSchemaShared;
exports.AgentAdConceptSchema = zod_1.default.object({
    language: zod_1.default.string().describe('The language of the concept as locale code e.g. en-US, de-DE, etc.'),
    title: zod_1.default.string().describe('A concise title for the concept').nullable(),
    shortDescription: zod_1.default
        .string()
        .describe('A concise few wordssummary of the overall concept that highlights the core idea')
        .nullable(),
    conceptReasoning: zod_1.default
        .string()
        .describe('Concise few words reasoning behind this concept; what it is based on and why it will win.')
        .nullable(),
    inputs: InputSchema,
    scenes: zod_1.default
        .array(exports.AgentAdConceptScenes)
        .describe("The array of all scenes that make the video.  Each scene is one visual composition that is visible for a certain amount of time / bound to the voiceover beneath it. One scene can only have one setting! 'Montages' cannot exist. If there are multiple settings, make multiple scenes for each setting. Do not have duplicate scenes with the same assets (e.g. two times the same screen recording after another) - in those cases just make the one scene longer"),
    backgroundMusics: zod_1.default.array(BackgroundMusicSchema),
    captions: CaptionsSchema,
});
